import { routes } from "routing";
import { lazyView, type RouteRender } from "routing/tree";
import i18n from "i18n/i18next";

export const activityFeedRoutes: RouteRender[] = [
  lazyView(
    routes.activityFeed,
    () => import("./activity-feed").then((m) => ({ default: m.ActivityFeedPage })),
    () => i18n.t("activityFeed.title"),
  ),
];
